import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useGetCompaniesQuery = getWrappedUseQuery(KEYS.GET_COMPANIES, apiClient.Companies.get);

export const useGetCompanyByIdQuery = getWrappedUseQuery(KEYS.GET_COMPANY_BY_ID, apiClient.Companies.getById);
